import { createFileRoute } from "@tanstack/react-router";
import { ExclusionsList } from "@/features/strateg-cenowy/components/exclusions-list";
import { useStrategScope } from "@/features/strateg-cenowy/use-strateg-scope";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/strateg-cenowy/wykluczenia")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.strateg-cenowy.wykluczenia",
			location.pathname,
		);
	},
	component: WykluczeniaPage,
});

function WykluczeniaPage() {
	const { scope } = useStrategScope();
	return <ExclusionsList scope={scope} />;
}
